<spb-header class="header"/>
<main id="main-content" class="spb-holder mat-typography">
  <h1 class="title">Sparbanken Syd - Räkna på ditt boende</h1>
  <section class="object-info" aria-label="Objektinformation">
    <spb-object-info/>
  </section>
  <div class="calc-holder">
    <section aria-label="Uppgifter för beräkning">
      <spb-input/>
    </section>
    <section aria-label="Resultat av beräkning">
      <spb-calculation/>
    </section>
  </div>
  <nav class="button-holder">
    <a matButton="filled" class="nav-button"
       [href]="calculatorUrl + '?' + calculatorQuery()"
       target="_blank"
       spbAccessibleLink>Räkna på ditt boende</a>
    <a matButton="filled" class="nav-button"
       [href]="`${environment.loanPromiseUrl}?hemnet=${hemnetService.savedId()}`"
       target="_blank"
       spbAccessibleLink>Ansök om lånelöfte</a>
    <a matButton="filled" class="nav-button"
       [href]="'https://www.sparbankensyd.se/sv/privat/vara-tjanster/bolan/ansokan-bolan' + utmTags"
       target="_blank"
       spbAccessibleLink>Ansök om bolån</a>
  </nav>
  <aside class="disclaimer">
    @for (p of interestService.disclaimerText(); track $index) {
      <p>{{ p }}</p>
    }
  </aside>
</main>
<div class="spb-filler"></div>
<footer>
  <spb-footer [license]="true" [version]="version"
              copyrightYears="2020"/>
</footer>
